import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import {
  useLocation,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";
import { convertToDateString, LoadingSpinner } from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { addMember } from "../ApiMember";
import LetterForCounsellingDataTable from "./LetterForCounsellingDataTable";
import LetterForCounsellingMemberDataContainer from "./LetterForCounsellingMemberDataContainer";

const AddLetterForCounselling = ({
  history,
  values,
  rafiqId,
  setRafiqId,
  setSerialNumber,
}) => {
  const location = useLocation();
  const currentDate = new Date();

  const letterForCounselling = location.state?.letterForCounselling;
  const letterFrequency = location.state?.letterFrequency;
  const letterYear = location.state?.letterYear;
  const calledAs = location.state?.calledAs;

  // Prioritize rafiqId if defined, otherwise use location.state?.memberId
  const memberId = rafiqId ?? location.state?.memberId;

  // Prioritize values if defined, otherwise use location.state?.memberValues
  const memberValues = values ?? location.state?.memberValues;

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [questionsList, setQuestionsList] = useState([]);
  const [letterColor, setLetterColor] = useState("");

  const [errorMessage, setErrorMessage] = useState({
    questions: "",
    selectedFrequency: "",
  });
  const [selectedDate, setSelectedDate] = useState(currentDate);

  useEffect(() => {
    const fetchQuestions = async () => {
      if (letterFrequency) setLoading(true);

      try {
        const res = await addMember().GetLetterForCounsellingQuestions(
          letterForCounselling?.value
        );

        const tempValues = res.data.memberLetterForCounsellingQuestions.map(
          (question) => ({ ...question, errorColor: "#ffffff" })
        );

        setErrorMessage((prev) => ({ ...prev, questions: "" }));
        setQuestionsList(tempValues);
        setLetterColor(res.data.letterColor);
      } catch (err) {
        swal({
          title: err?.message || "Something went wrong",
          icon: "error",
          buttons: "OK",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, [letterFrequency, letterForCounselling?.value, memberId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      questionsList.every((question) => question.rating !== 0) &&
      Object.values(errorMessage).every((x) => x === "") &&
      letterFrequency !== null &&
      Object.keys(letterFrequency).length !== 0
    ) {
      const values = {
        memberId: memberId,
        letterForCounsellingId: letterForCounselling?.value,
        letterFrequency: letterFrequency.value,
        receivedAt: convertToDateString(selectedDate),
        letterYear: letterYear,
        questions: questionsList,
      };
      setLoading(true);
      addMember()
        .AddMemberLetterForCounselling(values)
        .then((res) => {
          swal({
            title: t(
              "member_member_detail_letter_for_counselling_added_success"
            ),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: "OK",
          });

          if (rafiqId) {
            setRafiqId(undefined);
            setSerialNumber("");
            setLoading(false);
          } else {
            setLoading(false);
            history.goBack();
          }
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    } else {
      if (questionsList.some((question) => question.rating === 0)) {
        let tempValues = [...questionsList];

        tempValues = tempValues.map((question) => {
          if (question.rating === 0) {
            return { ...question, errorColor: "#FFEBEB" };
          }
          return question;
        });

        setQuestionsList(tempValues);
      }
      setErrorMessage({
        ...errorMessage,
        questions: questionsList.some((question) => question.rating === 0)
          ? "member_member_detail_letter_for_counselling_questions_error_message"
          : "",
        selectedFrequency:
          letterFrequency === null || Object.keys(letterFrequency).length === 0
            ? "member_member_detail_letter_for_counselling_already_exist_error_message"
            : "",
      });
    }
  };
console.log(letterForCounselling);

  return (
    <div
      className={
        rafiqId
          ? ""
          : "wrapper-custom wrapper wrapper-content animated fadeInRight"
      }
    >
      <div className="panel panel-primary">
        <div className="panel-heading">
          {" "}
          <Row>
            <Col md="10"></Col>
            <Col md="2">
              <Button
                color={rafiqId ? "primary" : "info"}
                size="sm"
                className={GetCustomStyles().btn_style}
                onClick={() => history.goBack()}
              >
                {rafiqId ? "" : <GetLanguageString props="unit_back_btn" />}
              </Button>
            </Col>
          </Row>
        </div>
        <div className="panel-body">
          <LetterForCounsellingMemberDataContainer
            memberValues={memberValues}
          />
          <br></br>
          <br></br>
          <Row>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="member_member_detail_letter_for_counselling_year" />
                  }
                </Label>
                <Input value={letterYear} disabled />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="settings_letter_for_counselling" />
                  }
                </Label>
                <Input
                  className={"ur"}
                  type="text"
                  disabled
                  value={letterForCounselling.label}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup style={{ marginTop: 5 }}>
                <Label>
                  {<GetLanguageString props="settings_event_type_frequency" />}
                </Label>

                <Input
                  className={"ur"}
                  type="text"
                  disabled
                  value={letterFrequency.label}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="member_member_detail_letter_for_counselling_received_date" />
                  }
                </Label>
                <DatePicker
                  showYearDropdown
                  disabled={calledAs === "view" || calledAs === "lfc"}
                  placeholderText="dd/mm/yyyy"
                  className="form-control"
                  selected={selectedDate}
                  maxDate={currentDate}
                  onChange={(d) => setSelectedDate(d)}
                  dateFormat="dd/MM/yyyy"
                />
              </FormGroup>
            </Col>
          </Row>{" "}
          {errorMessage.selectedFrequency && (
            <Row>
              <h5 className="text-error">
                * {<GetLanguageString props={errorMessage.selectedFrequency} />}
              </h5>
            </Row>
          )}
          {errorMessage.questions && (
            <Row>
              <h5 className="text-error">
                * {<GetLanguageString props={errorMessage.questions} />}
              </h5>
            </Row>
          )}
        </div>
      </div>
      {loading ? (
        LoadingSpinner()
      ) : questionsList.length !== 0 && letterFrequency !== null ? (
        <div
          className="panel panel-primary"
          style={{ borderColor: letterColor }}
        >
          <div className="panel-body">
            {!loading ? (
              <>
                <LetterForCounsellingDataTable
                  questionsList={questionsList}
                  setQuestionsList={setQuestionsList}
                  setErrorMessage={setErrorMessage}
                  errorMessage={errorMessage}
                  letterColor={letterColor}
                  calledAs={"add"}
                />
                <Row>
                  <div className={GetCustomStyles().btn_style}>
                    {" "}
                    <Button
                      color={"primary"}
                      size="sm"
                      className={GetCustomStyles().btn_style}
                      onClick={handleSubmit}
                    >
                      <GetLanguageString props="Submit" />
                    </Button>
                  </div>{" "}
                </Row>
              </>
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default withRouter(AddLetterForCounselling);
